const envProd = window.__env || {};

envProd.baseUrl = 'component-edge/';
envProd.enableDebug = false;

envProd.language = 'ENGLISH'; // FIXME THIS NEEDS TO BE TIED TO THE LANGUAGE OF THE DEPLOYMENT

envProd.dev = false;
envProd.intellidataApiUrl = 'https://search.kemet.com/intellidata/';
envProd.documentationUrl = 'https://search.kemet.com/component-documentation/';
envProd.datasheetUrl = 'https://content.kemet.com/datasheets/';
envProd.visualSearchFreshness = '05-15-2020'; // this is a time stamp to automatically expire the new badge.
export default envProd;
